import { cssVarColors } from 'lib/cssSelector'
import React, { FC } from 'react'
import { Classes } from 'jss'

import injectSheet, { Styles } from 'react-jss'
const { lightGray1 } = cssVarColors

interface DividerProps {
  orientation?: 'vertical' | 'horizontal'
  thickness?: number
  color?: string
  margin?: string
  classes: Classes
}

const styles: Styles = {
  divider: {
    height: '1px',
    backgroundColor: lightGray1
  }
}

const DividerComponent: FC<DividerProps> = ({ classes }) => {
  return <div className={classes.divider} />
}

export const Divider = injectSheet(styles)(DividerComponent)
